import { insertHorizontalRule } from './operations';

const slashMenu = {
  Divider: { icon: 'minus', basic: true, shortcut: '---', transform: insertHorizontalRule },
};

export default slashMenu;
